/* eslint-disable @typescript-eslint/member-ordering */
import { ID } from '@datorama/akita';
import { ColumnType, PageTitles } from '../interfaces/types';
import { Column, Entity } from '../entity';
import { IEntity } from '../interfaces/models';
import moment from 'moment';
import { DatePipe } from '@angular/common';

export interface IEventAssignment extends IEntity {
  vendorGroup: string;
  vendorAccountName: string;
  eventId: number;
  startDate: Date;
  startDateString: string;
  endDate: Date;
  endDateString: string;
}

@Entity({
  name: PageTitles.assignment,
})
export class EventAssignment implements IEventAssignment {
  @Column({
    type: ColumnType.string,
    table: {
      defaultPosition: 1,
    },
    form: {
      defaultPosition: 1,
    },
  })
  vendorGroup: string;

  @Column({
    type: ColumnType.date,
    isEditable: true,
    form: {
      defaultPosition: 2,
    },
  })
  startDate: Date;

  @Column({
    type: ColumnType.date,
    isEditable: true,
    form: {
      defaultPosition: 3,
    },
  })
  endDate: Date;

  @Column({
    type: ColumnType.string,
    table: {
      defaultPosition: 4,
      hide: true,
    },
    form: {
      defaultPosition: 4,
    },
  })
  createdBy: string;

  @Column({
    type: ColumnType.date,
    table: {
      defaultPosition: 5,
      hide: true,
    },
    form: {
      defaultPosition: 5,
    },
  })
  createdAt: Date;

  @Column({
    type: ColumnType.string,
    table: {
      defaultPosition: 6,
      hide: true,
    },
    form: {
      defaultPosition: 6,
    },
  })
  modifiedBy: string;

  @Column({
    type: ColumnType.date,
    table: {
      defaultPosition: 7,
      hide: true,
    },
    form: {
      defaultPosition: 7,
    },
  })
  modifiedAt: Date;

  id: ID;
  vendorAccountName: string;
  eventId: number;

  constructor(
    assignment: IEventAssignment = {
      id: '',
      vendorGroup: '',
      vendorAccountName: '',
      eventId: 0,
      startDate: new Date(),
      startDateString: '',
      endDate: new Date(),
      endDateString: '',
      createdBy: '',
      createdAt: new Date(),
      modifiedBy: '',
      modifiedAt: new Date(),
    }
  ) {
    const {
      id,
      vendorGroup,
      vendorAccountName,
      eventId,
      startDate,
      endDate,
      createdBy,
      createdAt,
      modifiedBy,
      modifiedAt,
    } = assignment;
    this.id = id;
    this.vendorGroup = vendorGroup;
    this.vendorAccountName = vendorAccountName;
    this.startDate = new Date(startDate);
    this.endDate = new Date(endDate);
    this.eventId = eventId;
    this.createdBy = createdBy;
    this.createdAt = createdAt;
    this.modifiedBy = modifiedBy;
    this.modifiedAt = modifiedAt;
  }

  @Column({
    type: ColumnType.string,
    table: {
      defaultPosition: 2,
    },
  })
  get startDateString(): string {
    const datepipe: DatePipe = new DatePipe('en-CA');
    const date = datepipe.transform(this.startDate, 'MMM dd, YYYY');

    return date.toString();
  }

  @Column({
    type: ColumnType.string,
    table: {
      defaultPosition: 3,
    },
  })
  get endDateString(): string {
    const datepipe: DatePipe = new DatePipe('en-CA');
    const date = datepipe.transform(this.endDate, 'MMM dd, YYYY');

    return date.toString();
  }

  // Since ion datepicker receives a string in iso 8601 and
  // returns a string, I created this property to manage that
  get createdAtFormatted(): string {
    return this.createdAt.toISOString();
  }

  set createdAtFormatted(date: string) {
    this.createdAt = new Date(date);
  }

  get startDateFormatted(): string {
    return this.startDate.toISOString();
  }

  set startDateFormatted(date: string) {
    this.startDate = new Date(date);
  }

  get endDateFormatted(): string {
    return this.endDate.toISOString();
  }

  set endDateFormatted(date: string) {
    this.endDate = new Date(date);
  }

  static createFromDTO(record: IEventAssignment): EventAssignment {
    return new EventAssignment(record);
  }
}
